<template>
  <b-container class="container--max-750 mt-6">
    <div class="c-infobox text-center">
      <h6 class="mb-1">{{ $t("lang.label_certificate_needHelp") }}</h6>
      <p>{{ $t("lang.label_certificate_learnMore") }}</p>
      <router-link class="btn btn-outline-primary" :to="{ name: 'quantum-safe-apps' }">{{ $t("lang.label_certificate_goToApps") }}</router-link>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "NeedInspirationComponent"
};
</script>

<style scoped></style>
